import { Center, Loader, Modal, ScrollArea, Stack, Text, TextInput } from "@mantine/core";
import { IMultipleFilterOptions } from "@mctypes/frontend.types";
import { IconListSearch } from "@tabler/icons-react";
import { useState } from "react";

function FreeTextSearch({
  search,
  onModalClose,
  manualIsLoading,
  children,
  placeholder,
  displayNoResultsText,
  multipleFilterItems,
  updateMultiFilterItemOption,
  clearAllFilters,
  resetMultiFilter,
  selectAllMultiFilter,
}: {
  search: (query: string) => Promise<void>;
  children?: React.ReactNode;
  manualIsLoading?: boolean;
  placeholder?: string;
  onModalClose: () => void;
  displayNoResultsText: boolean;
  multipleFilterItems?: IMultipleFilterOptions[];
  updateMultiFilterItemOption?: (title: string, value: string, searchQuery?: string) => void;
  clearAllFilters?: () => void;
  resetMultiFilter?: (dataField: string) => void;
  selectAllMultiFilter?: (dataField: string) => void;
}) {
  const [loading, setLoading] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [isOpen, setIsOpen] = useState(false);

  const executeSearch = async () => {
    if (searchQuery.trim() === "") {
      return;
    }

    setLoading(true);
    await search(searchQuery);
    setLoading(false);
  };

  const onUpdateMultiFilterItemOption = (title: string, value: string) => {
    updateMultiFilterItemOption?.(title, value, searchQuery);
  };

  const closeModal = () => {
    setSearchQuery("");
    setIsOpen(false);
  };

  return (
    <>
      <TextInput
        placeholder={placeholder != null ? placeholder : "Søk..."}
        onFocus={(e) => {
          e.target.blur();
          setIsOpen(true);
        }}
        size="sm"
        w={160}
        leftSection={<IconListSearch size={16} />}
      />
      <Modal opened={isOpen} onClose={closeModal} onExitTransitionEnd={onModalClose} title="Søk" size="40vw">
        <Stack h={500} gap="sm">
          <div>
            {/* {multipleFilterItems != null && (
              <MainFilterBar
                selectAllMultiFilter={selectAllMultiFilter}
                resetMultiFilter={resetMultiFilter}
                clearAllFilters={clearAllFilters}
                updateMultiFilterItemOption={onUpdateMultiFilterItemOption}
                multipleFilterItems={multipleFilterItems}
              />
            )} */}
            <TextInput
              autoFocus
              value={searchQuery}
              disabled={loading || manualIsLoading}
              styles={{ input: { fontSize: "1rem", paddingRight: "2.1rem" } }}
              placeholder={placeholder != null ? placeholder : "Søk"}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await executeSearch();
                }
              }}
              onChange={(e) => setSearchQuery(e.currentTarget.value)}
              onBlur={async () => {
                await executeSearch();
              }}
              rightSection={loading === true || manualIsLoading === true ? <Loader size={15} /> : null}
              rightSectionPointerEvents="none"
            />
          </div>
          <ScrollArea flex={1}>
            {displayNoResultsText === true ? (
              <Center>
                <Text c="dimmed" fs="italic">
                  Ingen søkeresultater funnet
                </Text>
              </Center>
            ) : (
              children
            )}
          </ScrollArea>
        </Stack>
      </Modal>
    </>
  );
}

export default FreeTextSearch;
